import { useState, useEffect, useRef } from 'react';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Helmet } from 'react-helmet-async';
import { Link as RouterLink, useNavigate, NavLink, useParams, useLocation } from 'react-router-dom';
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
import * as React from 'react';
// @mui
import { styled } from '@mui/material/styles';
import { Button, Typography, Container, Box, Modal } from '@mui/material';
import config from "../../config";
import { encryptData } from '../../utils/cryptoUtils';

import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/js/bootstrap.bundle';
import "bootstrap-icons/font/bootstrap-icons.css";
import '../common.scss';

import * as userActions from "../../actions/userActions";
import AccessDenied from '../common/AccessDenied';

import * as leadBankStatementActions from "../../actions/leadBankStatementActions";
import * as leadActions from "../../actions/leadActions";

// ----------------------------------------------------------------------

const StyledContent = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  minHeight: '100vh',
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  padding: theme.spacing(12, 0),
}));

// ----------------------------------------------------------------------


const BankStatementParser = (props) => {
  const { leadId, id } = useParams();
  const location = useLocation();
  const { actions, usersData, fetchLeadIdBankStatement ,camLatestStatus,leadInfo, leadFieldPermissions} = props;

  // Bank Statement add/edit permissions
  const hasAddPermission = !!leadFieldPermissions?.bank_statement?.add;
  const hasEditPermission = !!leadFieldPermissions?.bank_statement?.edit;
  const { register, handleSubmit, formState: { errors }, setValue, reset } = useForm();
  const navigate = useNavigate();

  const [addModulePermissionStatus, setAddModulePermissionStatus] = useState(false);
  const [editModulePermissionStatus, setEditModulePermissionStatus] = useState(false);
  const [userHasPermission, setUserHasPermission] = useState(true);
  const [permissions, setPermissions] = useState([]);

  const [allUsers, setAllUsers] = useState([]);
   const [selectedBankStatementFiles, setSelectedBankStatementFiles] = useState([]); // file upload
  const [getLeadId, setLeadId] = useState('');
  const [leadBankStatementId, setLeadBankStatementId] = useState('');// table id
  const [allLeadBankStatementByLeadData, setAllLeadBankStatementByLeadData] = useState([]);

  const [file, setFile] = useState('');
  const [uploadBankStatementId, setUploadBankStatementId] = useState('');
  

  const [currentPage, setCurrentPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState('');
  
  const [openBankDetails, setOpenBankDetails] = React.useState(false);
  const [bankDetails, setBankDetails] = useState('');

  const formRef = useRef(null);
  const [bankNameDropDown, SetBankNameDropDown] = useState([]);
  const [selectedBankName, setSelectedBankName] = useState(""); 
  const [isNoBankChecked, setIsNoBankChecked] = useState(false);


  const finboxBankStatementsData = () => {
    if (id !== undefined) {
      const decodedId = atob(id);
      const obj = { 'start': '0', 'length': config.MAX_RECORDS, "lead_id": atob(id) };
    const requestData = encryptData(obj);
    const response = actions.finboxBankStatements(requestData);

    response.then((result) => {
      // console.log("Promise resolved -  source data:", result); 
      if (result.data.success === 1) {
        const results = result.data.data.data;
        const resultArr = Object.keys(results).map((key) => results[key]);
        setAllLeadBankStatementByLeadData(resultArr);

        console.log('resultArr bank = ',resultArr)
      }
    }).catch((error) => {
      //  console.error("Promise rejected -  source data :", error); 
    });
  }
};

// Bank Name Dropdown start
useEffect(() => { 
  if (leadInfo?.data?.length > 0) {
    const noBankStatement = leadInfo.data[0]?.no_bank_statement;
     if(noBankStatement === '1'){
        setIsNoBankChecked(true);
     }else{
        setIsNoBankChecked(false);
     }
  }

  finBoxBankNameDropDownData();
}, [leadInfo]); 

const finBoxBankNameDropDownData = () => {
  const obj = { 'start': '0', 'length': config.MAX_RECORDS };
  const requestData = encryptData(obj);
  const response = actions.finBoxBankNameDropDown();
  response.then((result) => {
      if (result.data.success === 1) {
          const results = result.data.data;
          SetBankNameDropDown(results); 
      }
  }).catch((error) => {
      // handle error
  });
};
// Bank Name Dropdown End 

  useEffect(() => {
    // check user is logged-in or not
    const authToken = localStorage.getItem('authToken');
    if (authToken === null) {
      navigate('/login');
    }

    const obj = { 'start': '0', 'length': config.MAX_RECORDS };
    const requestData = encryptData(obj);
    actions.usersData(requestData);
    if (usersData.success) {
      setAllUsers(usersData.data);
    }

    finboxBankStatementsData();
  }, [setAllLeadBankStatementByLeadData]);


  

  const handleBankStatementFileChange = (e) => {
    const files = Array.from(e.target.files);
    const base64Files = [];

    files.forEach((file) => {
      const reader = new FileReader();
      reader.onload = (event) => {
        const base64Data = event.target.result;
        const fileName = file.name;
        base64Files.push({ file: base64Data, name: fileName });
        if (base64Files.length === files.length) {
          setFile(base64Files);
        }
      };
      reader.readAsDataURL(file);
    });
  };

  const onSubmit = (data) => {

    if(camLatestStatus ==='1'){
      toast.error("This lead has been approved by the Credit Head, you cannot modify the details", {
            position: "top-right",
        });
        return;
  }
    console.log("Onsubmit Data Upload Bank Statement", data)

    // const leadId = props.leadId;
    const leadId = '1';
    console.log('static leadId', leadId);
    setLeadId(leadId);

    if (!uploadBankStatementId && (!file || file.length === 0)) {
      toast.error("No file has been selected.", {
        position: "top-right",
      });
    } else if (data.bank_name.trim() === "") {
      toast.error("Bank Name is blank.", {
        position: "top-right",
      });
    } else {
      const params = { "lead_id": atob(id), "bank_name": data.bank_name, "file": file, "pdf_password": data.pdf_password };
      console.log("bankStatementParser : params :-", params)

      if (uploadBankStatementId !== '') {
        params.upload_bank_statement_id = uploadBankStatementId;
      }

      
      const requestData = encryptData(params);
      const response = actions.addEditUploadBankStatement(requestData);


      response.then((result) => {
            console.log("********************************************", result)

        if (result.data.success === 1) {
          toast.success(result.data.message, {
            position: "top-right",
          });
         
          finboxBankStatementsData();
          // setLeadBankStatementId(leadBankStatementId);
        //   fetchLeadIdBankStatement();
        //   reset();
        //   setSelectedBankStatementFiles("");
        //   props.updateParentState(false);
        } else {
          toast.error(result.data.message, {
            position: "top-right",
          });
        }
      }).catch((error) => {
        toast.error(error, {
          position: "top-right",
        });
      });
    }
  };
//   console.log("allLeadBankStatementByLeadData =", allLeadBankStatementByLeadData);
  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  const filteredItems = (allLeadBankStatementByLeadData ?? []).filter(item =>
    item.formatetdID.toLowerCase().includes(searchQuery.toLowerCase()) ||
    item.createdByName.toLowerCase().includes(searchQuery.toLowerCase())
  );
 
  const startIndex = (currentPage - 1) * config.ITEMS_PER_PAGE;
  const endIndex = startIndex + config.ITEMS_PER_PAGE;
  const paginatedItems = filteredItems.slice(startIndex, endIndex);
  const totalPages = Math.ceil(filteredItems.length / config.ITEMS_PER_PAGE);

  const docViewUrl = `${config.API_BASE_URL}uploads/finbox_bank_statements/`;
  

   const handleCloseBankDetails = () => {
    setOpenBankDetails(false); 
    setBankDetails(''); 
 };

  const onRowClickAction = (itemObj, btnAction) => {

    if (btnAction === 'view') {
         setOpenBankDetails(true);
        setBankDetails(itemObj.response_data);
    }else if (btnAction === 'edit') {
      if (formRef.current) {
        formRef.current.scrollIntoView({ behavior: 'smooth' });
      }

      setLeadBankStatementId(itemObj.bank_statement_id);
      setValue("bank_statement_file", docViewUrl + itemObj.bank_statement_file);      
      setValue("bank_statement_note", itemObj.bank_statement_note);

    } else if (btnAction === "delete") {
      const leadId = props.leadId;
      const obj = { "lead_id": leadId, "id": itemObj.bank_statement_id, "basic_info_type": "bank_statement" };
      const requestData = encryptData(obj);
      const response = actions.deleteLeadBasicInfo(requestData);
      response.then((result) => {
         console.log("Promise resolved - deleteLeadBasicInfo result:", result);
        if (result.data.success === 1) {
          toast.success(result.data.data.message, {
            position: "top-right",
          });

          fetchLeadIdBankStatement();
          props.updateParentState(false);

        } else {
          toast.error(result.data.data.message, {
            position: "top-right",
          });
        }
      }).catch((error) => {
        toast.error(error, {
          position: "top-right",
        });
      });
    }
  }

  const handleNewButton = () => {
    setLeadBankStatementId("");
    setSelectedBankStatementFiles("");
    reset();
  }

  const handleNoBank = (event) => {
    setIsNoBankChecked(event.target.checked);    
  };

  const onSubmitV2 = (data) => { 
      
      const noBankStatementStatus = (data.no_bank_statement) ? 1 : 0;      
      const params = { "lead_id": atob(id), "status": noBankStatementStatus}; 
       
      const requestData = encryptData(params);
      const response = actions.updateLeadBankStatus(requestData);
      response.then((result) => { 
        if (result.data.success === 1) {
          toast.success(result.data.message, {
            position: "top-right",
          });          
        } else {
          toast.error(result.data.message, {
            position: "top-right",
          });
        }
      }).catch((error) => {
        toast.error(error, {
          position: "top-right",
        });
      });
  };

  return (
    <>
      <h5 className="fw-bold">Bank Statement Parser</h5>
     {hasAddPermission && (
      <div id='main-wrap'  className= "mb-3 mmt-7 filter">
                  <form onSubmit={handleSubmit(onSubmitV2)}>
                      <div className='row mx-0'>                        
                          <div className='col-'>
                              <div className='form-group'>
                                  <label htmlFor="keyword"> 
                                      <input type='checkbox' name='no_bank_statement' id='no_bank_statement' 
                                      {...register('no_bank_statement')} 
                                      checked={isNoBankChecked}
                                      onChange={handleNoBank}/> I DO NOT HAVE A BANK STATEMENT TO UPLOAD  <button className='btn btn-primary'>Submit</button>
                                  </label>
                              </div>
                          </div>
                         
                      </div>
                  </form>
              </div>
     )}

      {(leadBankStatementId === '' ? hasAddPermission : hasEditPermission) && (
      <div id="main-wrap" className='mt-4'>
        <div className='row justify-content-between'>

          <div className="row">
            <div className='col-md-9'>
              <h5> {leadBankStatementId === '' ? 'Add' : "Edit"} Bank Statement Parser</h5>

             
            </div>
            {leadBankStatementId !== '' && (
              <div className='col-md-3'>
                <div className='form-group text-end mb-2'>
                  <button className="btn btn-primary" onClick={() => handleNewButton()}>Add New</button>
                </div>
              </div>
            )}  
          </div>

          <form onSubmit={handleSubmit(onSubmit)} encType="multipart/form-data" ref={formRef}>
            <div className="row" id="bank-statement-1">
              <div className="col-md-4">
                <div className="form-group">
                  <label htmlFor="file">
                    <span>File Upload <a style={{ color: "red" }}>*</a></span>
                    <input type='file' id='file' name='file' className='form-control' onChange={handleBankStatementFileChange} />
                  </label>
                </div>
              </div>
                {/* <div className='col-md-4'>
                    <div className='form-group'>
                    <label htmlFor="bank_name">
                        <span>Bank Name <a style={{ color: "red" }}>*</a></span>
                        <input 
                        id='bank_name'
                        className='form-control'
                        {...register('bank_name')}
                        />
                    </label>
                    </div>
                </div> */}
                <div className="col-md-4">
                  <div className="form-group">
                    <label htmlFor="bank_name">
                        <span>Bank Name <a style={{ color: "red" }}>*</a></span>
                        <select 
                              id="bank_name" 
                              name="bank_name" 
                              className="form-select" 
                              {...register('bank_name')} 
                              value={selectedBankName}
                              onChange={(e) => setSelectedBankName(e.target.value)} 
                          >
                              <option value="">Select Bank</option>
                              {/* {console.log("Bank Name Dropdown:", bankNameDropDown)} / */}
                              {Array.isArray(bankNameDropDown.bank_name) && bankNameDropDown.bank_name.length > 0 ? (
                                  bankNameDropDown.bank_name.map((option, index) => (
                                      <option key={index} value={option.bank_name}>
                                          {/* {option.bank_name} */}
                                          {option.bank_name.replace(/_/g, ' ')}
                                      </option>
                                  ))
                              ) : (
                                  <option disabled>No banks available</option>
                              )}
                          </select>
                      </label>
                  </div>
                </div>

                <div className='col-md-4'>
                    <div className='form-group'>
                    <label htmlFor="pdf_password">
                        <span>Password</span>
                        <input 
                        id='pdf_password'
                        className='form-control'
                        {...register('pdf_password')}
                        />
                    </label>
                    </div>
                </div>

            </div>

            <div className="row">
              <div className="col-md-12">
                <div className="form-group mb-0">
                  <button className="btn btn-primary">Submit</button>
                </div>
              </div>
            </div>

          </form>
        </div>
      </div>
      )}

      <div id="main-wrap" className='mt-4'>
        <div className="table-wrap">
          <table className="table table-hover">
            <thead>
              <tr>

                <th>Bank Statement ID</th>
                <th>Created Date</th>
                <th>View File</th>
                 <th>View Output</th>
                
              </tr>
            </thead>

            {paginatedItems.length === 0 ? (
              <tbody> 
                <tr>
                  <td colSpan="3" style={{ textAlign: 'center' }}>
                    <h5>No Bank Statement </h5>
                  </td>
                </tr>
              </tbody>
            ) : (
              <tbody>
                {paginatedItems.map((item, index) => (
                  <tr key={index}>
                    <td>{item.formatetdID}</td>
                    <td>{item.created_at}</td>
                    <td>
                      <span className="badge text-bg-success text-white">
                        <a target="new" href={docViewUrl + item.bank_statement_file} className='text-success text-decoration-none'>
                          <i className="bi bi-eye">&nbsp;</i>
                        </a>
                      </span>
                    </td>
                   
                      <td>
                        <div className="btn-group dropstart">
 
                        {item.excel_generated && item?.excel_file_url && (
                          <a 
                            target="_blank" 
                            rel="noopener noreferrer" 
                            href={item.excel_file_url} 
                            className="text-success text-decoration-none"
                          >
                            <i className="bi bi-eye">&nbsp;</i>
                          </a>
                        )}


                       {/* <button
                         onClick={() => onRowClickAction(item, 'view')}
                         className="page-link"
                      >
                        <i className="bi bi-eye">&nbsp;</i>
                      </button> */ }

                           
                        </div>
                      </td> 

                  </tr>
                ))}
              </tbody>
            )}
          </table>
        </div>

        <div>
          <nav className='mb-1'>
            <ul className="pagination pagination-md justify-content-end">
              {Array.from({ length: totalPages }, (_, index) => index + 1).map(page => (
                <li className="page-item">
                  <button
                    key={page}
                    onClick={() => handlePageChange(page)}
                    disabled={currentPage === page}
                    className="page-link"
                  >
                    {page}
                  </button>
                </li>
              ))}
            </ul>
          </nav>
        </div>
      </div> 

      <Modal
            open={openBankDetails}
            onClose={handleCloseBankDetails}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <div className='modal-custom rounded'>
                <div className='modal-head'>
                    <h4 id="modal-title">View Bank Details</h4>
                    <Button onClick={handleCloseBankDetails} color="primary" className=' btn'>
                        <i className="bi bi-x">&nbsp;</i>
                    </Button>
                </div>
                
                <div className='modal-body'>
                    <div> 
                        <div className="row mx-0">
                           {bankDetails}
                        </div> 
                    </div>
                </div>
            </div>
        </Modal> 
    </>
  );
}


function mapStateToProps(state) {
  return {
    usersData: state.usersData,
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(Object.assign(userActions.default, leadBankStatementActions.default, leadActions.default), dispatch),
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(BankStatementParser);
